export const GoodsClassifierItemsPluginSettings: IPluginSettings = {
    name: "Товары в выбранной группе",
    mnemocode: "goods_classifier_items_plugin",
    permission: "GoodsClassifier",
    columns: [
        {
            order: 0,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "idGlobal",
            visibility: false,
            width: 200,
        },
        {
            order: 1,
            propertyName: "goodsName",
            propertyType: "string",
            displayName: "Товар",
            visibility: true,
            width: 200,
        },
        {
            order: 2,
            propertyName: "code",
            propertyType: "string",
            displayName: "Код",
            visibility: true,
            width: 200,
        },
        {
            order: 3,
            propertyName: "producerName",
            propertyType: "string",
            displayName: "Производитель",
            visibility: true,
            width: 200,
        },
        {
            order: 4,
            propertyName: "countryName",
            propertyType: "string",
            displayName: "Страна",
            visibility: true,
            width: 200,
        },
        {
            order: 5,
            propertyName: "substanceName",
            propertyType: "string",
            displayName: "Действ. вещество",
            visibility: true,
            width: 200,
        },
        {
            order: 6,
            propertyName: "classifierName",
            propertyType: "string",
            displayName: "Группа аналогов",
            visibility: true,
            width: 200,
        },
        {
            order: 7,
            propertyName: "rating",
            changeable: true,
            propertyType: "number",
            displayName: "Рейтинг",
            visibility: true,
            width: 200,
        },
        {
            order: 8,
            propertyName: "deleted",
            propertyType: "boolean",
            displayName: "Удалено",
            visibility: true,
            width: 200,
        },
    ]
}